// extracted by mini-css-extract-plugin
export default {"box":"i6vHwVCohr3pmmq7swaC","tabList":"JJY9gaxwnZqnD4cjlr5l"};